const PAGE_SIZE = 20;

/**
 * 1027 「要不要显示一共多少条」:高德 v5 不给命中总数(只有 hasMore),搜索中途报不出真「共 N 条」。
 * 中途报「已找到 N 个,还有更多」(N = 已翻过的页 + 本页);翻到底(无下一页)时总数就是准的,报「共 N 个」。
 */
export function leadCountLabel(page: number, pageItems: number, hasMore: boolean): string {
  const seen = (Math.max(1, page) - 1) * PAGE_SIZE + pageItems;
  return hasMore ? `已找到 ${seen} 个潜在客户,还有更多` : `共 ${seen} 个潜在客户`;
}
